(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7704],{

/***/ 67704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39181);
/* harmony import */ var _DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3921);
/* harmony import */ var _DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var DrivingInnovation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pageWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: (_DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().drivingInnovationSection),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().drivingInnovationContent),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().drivingInnovationText),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .ZT, {
                                variant: "display-lg",
                                as: "h2",
                                color: "primary",
                                children: "Driving Innovation with Precision and Purpose"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .ZT, {
                                variant: "text-xl",
                                color: "grayDark-400",
                                children: "Design, compile, and deploy professional video processing plugins across all major editing platforms with a single visual workflow."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_DrivingInnovation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().imageGallery),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/product-drivingInnovation.svg",
                        alt: "VxFX Framework Driving Innovation in Video Plugin Development - Visual Workflow Design"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DrivingInnovation);


/***/ }),

/***/ 3921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"DrivingInnovation_pageWrapper__iPeHM","drivingInnovationSection":"DrivingInnovation_drivingInnovationSection__K3JFC","drivingInnovationContent":"DrivingInnovation_drivingInnovationContent__XTj0I","drivingInnovationText":"DrivingInnovation_drivingInnovationText__5DB1K","imageGallery":"DrivingInnovation_imageGallery__ugH3H"};

/***/ })

}]);